@if (isPayableAffiliate) {
    <div class="balance">
        <div class="balance-labels">

            <prl-balance-item class="first-label"
                              [label]="getLeftLabel()"
                              [value]="getLeftValue()">
            </prl-balance-item>

            <prl-balance-item class="extra-label"
                              [label]="getCenterLabel()"
                              [value]="getCenterValue()">
            </prl-balance-item>

            <prl-balance-item class="extra-label"
                              [label]="getRightLabel()"
                              [value]="getRightValue()">
            </prl-balance-item>
        </div>

        <mx-info-tooltip [config]="balanceConfig"></mx-info-tooltip>
    </div>
}